import React, { Suspense, useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import ToolBar from './ToolBar';
import xrpdata from "./data/xrp"
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import Button from '@mui/material/Button';
import SideNav from './components/SideNav';
import { isMobile } from './Hero';



function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

const capsFirstLetter = (text) =>{
  return text[0].toUpperCase() + text.slice(1);
}
  const save = async(coin,data) =>{
    let url = ''
    if(coin ==="Bitcoin"){
      url = 'saveBitcoin'
    }
    else if(coin === "ethereum"){
      url = 'saveEthereum'
    }
    else if(coin === "tron"){
      url = 'saveTron'
    }    
    else if(coin === "bnb"){
      url = 'saveBnb'
    }        
    if(coin && coin === 'okb'){
      url = 'saveBnb'
    }
        const response = await fetch("/api/"+url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
  }
    const submitData = async (coin) => {
        try {
            const response = await fetch("/api/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    crypto: coin,
                })
            });

            if (!response.ok) {
                throw new Error("Failed to submit data");
            }

            const data = await response.json();
        } catch (error) {
            console.error("Error:", error);
            
        }
    };

function Trade(){
    const[bitcoinPrice, setBitcoinPrice] = useState(0)
    const[crypto, setCrypto] = useState(sessionStorage.getItem("crypto"))
    const[changed, setChanged] = useState(false)
    const[initData ,setInitialData] = useState([])
    const[bitData, setBitData] = useState([])
    const[globalLink, setGlobalLink] = useState("http://ec2-3-107-164-43.ap-southeast-2.compute.amazonaws.com/")
    const sideNavItems = [{link:setCrypto, item:"Bitcoin" , bug:""},{link:setCrypto, item:"Ethereum" , bug:""},{link:setCrypto, item:"Tron" , bug:""},{link:setCrypto, item:"BNB" , bug:""},{link:setCrypto, item:"OKB" , bug:""}]
    let savedBitcoin = false
    let first = true
    let firstSetData = true
    let firstEntry = {}
    let click = false
    let countSave = 0

    useEffect(() => {
         const currentUrl = window.location.href;
         if(currentUrl.includes("local")){
            setGlobalLink("http://localhost:3000/")
         }
         else{
            setGlobalLink("http://ec2-3-107-164-43.ap-southeast-2.compute.amazonaws.com/")
         }
          console.log('init Data ', initData)
      }, [crypto, initData])
      function loadData() {
        // return initData;
        if(crypto==="Bitcoin"){
          return initData

        }
        else if(crypto==="ethereum"){
          return initData
        }
        else if(crypto==="tron"){
          return initData
        }
        else if(crypto==="bnb"){
          return initData
        }       
         else if(crypto==="okb"){
          return initData
        } 
       }
      let properties = {
      options: {
        candlestick: {
          colors: {
            upward: '#3C90EB',
            downward: '#DF7D46'
          },
          wick: {
            useFillColor: true,
          },

        }
      },
      series: [{
        xaxis: {
          type: "datetime",
        },
        yaxis: {
          type: 'numeric',
          min: 1000, // Minimum value of the Y-axis
          max: 10000, // Maximum value of the Y-axis
          tickAmount: 1000, // Number of ticks on Y-axis
        },
        data: loadData()
      }]
    };

      let propertiesnew = {
      options: {
        candlestick: {
          colors: {
            upward: '#3C90EB',
            downward: '#DF7D46'
          },
          wick: {
            useFillColor: true,
          },
          zoom: {
            enabled: true
          },
        }
      },
      series: [{
        xaxis: {
          type: "datetime",
        },
        yaxis: {
          type: 'numeric',
          min: 100000,  // Minimum value on the Y-axis
          max: 150000, // Maximum value on the Y-axis
          tickAmount: 1 ,// Number of ticks (grid lines)
          forceNiceScale: false, 
          stepSize:200
        },
        data: [
        ]
      }]
    };
    let propertyThird = {
      options: {
        candlestick: {
          colors: {
            upward: '#3C90EB',
            downward: '#DF7D46'
          },
          wick: {
            useFillColor: true,
          },

        }
      },
      series: [{
        xaxis: {
          type: "datetime",
        },
        yaxis: {
          type: 'numeric',
          min: 1000, // Minimum value of the Y-axis
          max: 10000, // Maximum value of the Y-axis
          tickAmount: 1000, // Number of ticks on Y-axis
        },
        data: []
      }]
    };

  const [property , setProperty] = useState(propertiesnew)
  const [upperProperty , setUpperProperty] = useState(properties)

    const getCrypto = async(coin) =>{
    
    try{
    let response = await Promise.resolve(fetch('/api/'+ coin) ,{ cache: "no-store" });
    //console.log('pls change ',crypto)
    if(!response.ok){
        throw new Error
    }
    const data = await response.json();
    let {cryptoPrice} = data
    const price = parseFloat(cryptoPrice.replace(/[$,]/g, ''));

     console.log('bitcoinPrice ',price)
    if(!price || price === 0){
      return
    }

    propertiesnew.series[0].yaxis.min = price - 500
    propertiesnew.series[0].yaxis.max = price + 500
    let clonedObject = structuredClone(propertiesnew);
    let clonedObjectUpper = structuredClone(properties);
    console.log('crypto set',crypto)
    if(firstSetData && crypto === 'Bitcoin'){
      properties.series[0].data = await submitDataIntermediate(coin)
      firstSetData = false
    }
    if(firstSetData && crypto === 'ethereum'){
      properties.series[0].data = await submitDataIntermediate(coin)
      firstSetData = false
    }
    if(firstSetData && crypto === 'tron'){
      properties.series[0].data = await submitDataIntermediate(coin)
      firstSetData = false
    }
    if(firstSetData && crypto === 'bnb'){
      properties.series[0].data = await submitDataIntermediate(coin)
      firstSetData = false
    }   
    if(firstSetData && crypto === 'okb'){
      properties.series[0].data = await submitDataIntermediate(coin)
      firstSetData = false
    }       
    let arr = propertiesnew.series[0].data;
    let arrUpper =  properties.series[0].data 
    console.log('here init ', properties.series[0].data )
    console.log('properties ',properties)
    
    setBitcoinPrice(price.toFixed(2))
    if(coin === 'bitcoin'){
        setCrypto('Bitcoin') 
    }
    else{
      setCrypto(coin)
    }
     
    if(arr.length > 0){

      let prevPrice = arr[arr.length-1].y[3]
      let prevPriceNum = parseFloat(prevPrice)
      let high=0 , low= 0
      let diff = Math.abs(prevPriceNum - price.toFixed(2)) /10
      let highDiff = diff
      let lowDiff = diff
      if(!prevPrice){
        prevPrice = 0
      }
      let medium = ( parseFloat(prevPrice) + price) /2
      
      if(parseFloat(prevPrice) > price ){
          high = (prevPriceNum+diff).toFixed(2)
          low  = (price - diff).toFixed(2)
          highDiff = 0
      }
      if(parseFloat(prevPrice) < price ){
          high = (price+diff).toFixed(2)
          low  = (prevPriceNum - diff).toFixed(2)
          lowDiff = 0
      }      
      let entry = { x: new Date() , y:[prevPrice,high, low,price.toFixed(2)]}
      if(prevPrice === price.toFixed(2) ){

      }
      else{
        if(first){
          firstEntry = entry
          first = false
        }
        arrUpper.push(entry)
        arr.push(entry)
        if (arrUpper.length >100){
          let rEle = arrUpper.splice(0, 1);
        }
        countSave ++
        if (firstEntry.y === arrUpper[0].y && crypto === 'Bitcoin') {
          console.log('saved bitcoin')
          save(crypto,arrUpper)
          savedBitcoin = true
        }
        if(savedBitcoin && countSave>30){
          save(crypto,arrUpper)
          countSave = 0
        }

      }
      prevPrice = price.toFixed(2)
    }
    else{
      let prevUpperPrice = arrUpper[arrUpper.length-1].y[3]
      let entry = { x: new Date() , y:[prevUpperPrice,price.toFixed(2),price.toFixed(2),price.toFixed(2)]}
      let upperEntry = { x: new Date() , y:[prevUpperPrice,price.toFixed(2),price.toFixed(2),price.toFixed(2)]}
      arrUpper.push(upperEntry)
      arr.push(entry)
    }
    clonedObject.series[0].data = arr;
    setProperty(clonedObject)
    setUpperProperty(clonedObjectUpper)
    return data
    }
    catch(error){
      console.log(error);
    }

  
  }
      window.addEventListener('popstate', function(event) {
        // Code to execute when the back button is clicked
        window.location.reload(true);

      });
  const runAsy = async(coin)=>{
        
        while(true){
            console.log('coin',coin)
        const result2 =   await getCrypto(coin);
        await delay(1000); 
        if(changed === true){
          break;
        }

     }
  }
  const submitDataIntermediate= async (coin)=>{
    console.log('intermediate coin ',coin)
    if(coin === 'bitcoin'){
          const bitData = await fetch('/api/getBitcoinJson')
          const result = await bitData.json()
          setInitialData(result)
          console.log('returned ',result)
          return result     
    }
    else if(coin === 'ethereum'){
          const bitData = await fetch('/api/getEthereumJson')
          const result = await bitData.json()
          setInitialData(result)
          console.log('returned ',result)
          return result    
    }
    else if(coin === 'tron'){
          const bitData = await fetch('/api/getTronJson')
          const result = await bitData.json()
          setInitialData(result)
          console.log('returned ',result)
          return result    
    }
    else if(coin === 'okb'){
          const bitData = await fetch('/api/getOkbJson')
          const result = await bitData.json()
          setInitialData(result)
          console.log('returned ',result)
          return result    
    }  
    else if(coin === 'bnb'){
          const bitData = await fetch('/api/getBnbJson')
          const result = await bitData.json()
          setInitialData(result)
          console.log('returned ',result)
          return result    
    }  
   
   return {}

  }
  let firstRender = false
  useEffect(()=>{
    const coin = sessionStorage.getItem("crypto") ?? 'bitcoin'
    
    if(coin && coin === 'bitcoin'){
      setCrypto('Bitcoin')
    }

    if(coin && coin === 'tron'){
      setCrypto('tron')
    }

    if(coin && coin === 'bnb'){
      setCrypto('bnb')
    }    
    if(coin && coin === 'ethereum'){
      setCrypto('ethereum')
    }
    if(coin && coin === 'okb'){
      setCrypto('okb')
    }
    if(!firstRender){
      submitDataIntermediate(coin)
      
    if(!click){
      runAsy(coin)
    }
    firstRender = true
    }


  },[crypto, changed])

    useEffect(()=>{
      //important to separate useffect bug caused
    },[bitcoinPrice])

    useEffect(()=>{
      //important to separate useffect bug caused
    },[property])
    return(<>
      {bitcoinPrice>0 ?(
      <Suspense fallback={<div>Loading...</div>}>
      <>
      <body id="main" style={{backgroundColor:"black" ,textAlign: 'center'}} className={'background_gradient_project'}>
      
      <ToolBar showToolBar={false}/>
      <div style={{paddingTop:'50px'}}>
      <div style={{}}> 
      <div style={{display:"flex",justifyContent:"center"}}>
      {isMobile()? <SideNav style={{width:"0px",paddingLeft:"100px"}}items={sideNavItems} ></SideNav> :  <SideNav style={{paddingLeft:"100px"}}items={sideNavItems} ></SideNav>}
      <div style={{height:"100px",width:"1000px"}}>
      <div className={'flex-container'}>
      <IconButton onClick={()=>{console.log('click');window.location.href = globalLink;}} style={{color:'white'}}size={'large'} children={<ArrowBackIcon></ArrowBackIcon>}/>
      {/* <img onClick={()=>{window.location.href = 'http://ec2-3-27-28-199.ap-southeast-2.compute.amazonaws.com/';}} width={100} height={100}/> */}
      <Button style={{fontWeight:'bold'}} onClick={()=>{setCrypto('Bitcoin'); sessionStorage.setItem("crypto", "bitcoin"); window.location.href = globalLink+'trade';}}variant="contained" color="success">
           Bitcoin 
      </Button>
      <div style={{paddingLeft:'10px'}}></div>    
      <Button style={{fontWeight:'bold'}} onClick={()=>{setCrypto('ethereum'); sessionStorage.setItem("crypto", "ethereum");  window.location.href = globalLink+'trade';}}variant="contained" color="success">
           Ethereum 
      </Button>      
      <div style={{paddingLeft:'10px'}}></div>  
      <Button style={{fontWeight:'bold'}} onClick={()=>{setCrypto('tron'); sessionStorage.setItem("crypto", "tron");  window.location.href = globalLink+'trade';}}variant="contained" color="success">
           Tron 
      </Button>   
      <div style={{paddingLeft:'10px'}}></div>     
      <Button style={{fontWeight:'bold'}} onClick={()=>{setCrypto('bnb'); sessionStorage.setItem("crypto", "bnb");  window.location.href = globalLink+'trade';}}variant="contained" color="success">
           BNB 
      </Button>  
      <div style={{paddingLeft:'10px'}}></div>  
      <Button style={{fontWeight:'bold'}} onClick={()=>{setCrypto('okb'); sessionStorage.setItem("crypto", "okb");  window.location.href = globalLink+'trade';}}variant="contained" color="success">
           OKB 
      </Button>              
      <div style={{paddingLeft:'10px'}}></div>       
      </div>      
          </div>
        </div>
      
      <div style={{paddingTop:'5px'}}>
      <div style={{display:"flex",justifyContent:"center"}}>
          <h3 style={{color:'white',fontWeight:'bold'}} className={'font-montserrat text-lg'}>{capsFirstLetter(crypto)} Price USD : {bitcoinPrice}</h3> 
      </div>
        <div style={{display:"flex",justifyContent:"center"}}>
        <div className="row">
          <div className="mixed-chart">
            {crypto === 'Bitcoin' || crypto ==='ethereum'?(<>
            <Chart
              options={properties.options}
              series={properties.series}
              type="candlestick"
              width="1000"
              height={500}
            />            
            </>):(<>
            <Chart
              options={properties.options}
              series={properties.series}
              type="candlestick"
              width="1000"
              height={500}
            />               
            </>)}
          </div>
        </div>
      </div>
        </div>
      <div style={{}}className="app">
      <div style={{display:"flex",justifyContent:"center"}}>
          <div>
          <h3 style={{color:'white',fontWeight:'bold'}} className={'font-montserrat text-lg'}>{capsFirstLetter(crypto)}</h3> <br/>
          <h3 style={{color:'white',fontWeight:'bold'}} className={'font-montserrat text-lg'}>Recent change in price USD : {bitcoinPrice}</h3> 
          </div>

      </div>
        <div style={{display:"flex",justifyContent:"center"}}>
          <div className="row">
          <div className="mixed-chart">
            <Chart
              options={property.options}
              series={property.series}
              type="candlestick"
              width="1000"
              height={500}
            />
          </div>
        </div>       
        </div>

      </div>
        </div>
        </div>
      </body>

      </>
    </Suspense>
      ):(
        <>
        <body style={{backgroundColor:"black" ,textAlign: 'center',height: "100%",position:"relative"}}>
          <div className='center-icon'>
            {/* <div style={{display:"flex",flexDirection:"column"}}> */}
              <HourglassTopIcon className ={"rotate-icon"}style={{color:'white'}}sx={{ fontSize: 100 }}/>
            {/* </div> */}
          </div>
          
        </body>
        </>
      )}

    </>)
}

export default Trade